import type { PillTone } from "@/components/ui/pill";
import type { AttentionOccurrence } from "@/types/attention.types";
import { getEventTypeLabel } from "@/lib/display-labels";

// Rótulos canônicos dos status de atenção, compartilhados entre
// o card "Atenção da linha" e a sidebar de máquina para não divergirem.
export const ATTENTION_STATUS_META: Record<
  AttentionOccurrence["statuses"][number],
  { label: string; tone: PillTone }
> = {
  ACTIVE: { label: "Ativo", tone: "danger" },
  PENDING_JUSTIFICATION: { label: "Justificativa pendente", tone: "warning" },
};

export function occurrenceTitle(o: AttentionOccurrence): string {
  if (o.alarm) return o.alarm.title;
  if (o.justification?.type === "NODATA") return "Sensor sem dados";
  return "Parada aguardando justificativa";
}

// Tipo exibido da ocorrência: alarme isolado vs parada/sem-dados (reusa o catálogo
// pt-BR de getEventTypeLabel — não reimplementar o mapa de EventType).
export function occurrenceType(o: AttentionOccurrence): string {
  return o.justification ? getEventTypeLabel(o.justification.type) : "Alarme";
}

// Derivações de domínio centralizadas (antes espalhadas inline por ≥3 componentes).
export function isAlarmActive(o: AttentionOccurrence): boolean {
  return o.alarm?.state === "UNACKNOWLEDGED" || o.alarm?.state === "ACKNOWLEDGED";
}

export function canJustify(o: AttentionOccurrence): boolean {
  return o.justification?.reasonStatus === "PENDING";
}
